import { copy } from "../content/copy";

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-24 md:py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <div className="label-caps mb-4">{copy.how.label}</div>
          <h2 className="font-display text-5xl md:text-7xl text-cream">{copy.how.heading}</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {copy.how.steps.map((s) => (
            <div key={s.n} className="card p-6 group relative overflow-hidden">
              <div className={`font-display text-5xl ${s.accent} mb-4`}>{s.n}</div>
              <h3 className="text-2xl font-semibold text-cream mb-2">{s.title}</h3>
              <p className="text-cream/75 leading-relaxed">{s.body}</p>
              <div className="absolute -bottom-10 -right-10 w-32 h-32 rounded-full bg-coral/10 blur-2xl group-hover:bg-coral/30 transition-colors duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
